import { useMutation } from '@apollo/client';
import { PATCH_PROXY_OBJECT } from '../gql/mutations';

export const usePatchProxyObject = () => {
    const [ patchProxyObjectMutation ] = useMutation( PATCH_PROXY_OBJECT );
    
    const patchProxyObject = async ( { id, companyIntegrationId, fieldData } ) => {
        try {
            const variables = {
                'input': {
                    id,
                    companyIntegrationId,
                    fieldData: {
                        ...fieldData
                    }
                }
            };
            
            const response = await patchProxyObjectMutation( { variables } );
            const success = !( response?.error || response?.errors && response?.errors?.length > 0 );
            
            if ( success ) {
                return `${ response.data.result.id }`;
            } else {
                console.error( 'Error at patchProxyObject' );
                return { error: true };
            } 
        } catch ( error ) { 
            console.error( 'Error at patchProxyObject', error );
            return { error: true };
        }
    };

    return {
        patchProxyObject
    };
};
